// PNJ "standee" : un personnage statique dont la texture est un portrait DiceBear.
// On hérite de Npc (donc du système d'interaction du moteur), mais on l'ajoute à GridEngine
// SANS walkingAnimationMapping -> le sprite reste figé (un portrait ne marche pas en 4 directions).
//
// Pour un PNJ qui se déplace avec animation, utiliser la classe Npc avec un vrai spritesheet.
import { Direction, WalkingAnimationMapping } from 'grid-engine'
import { Npc } from './Npc'

export class AvatarNpc extends Npc {
    // Override : ajout à GridEngine en mode statique (pas de mapping d'animation de marche).
    addCharacter(
        npcSprite: Phaser.Physics.Arcade.Sprite,
        xPosition: integer,
        yPosition: integer,
        container: Phaser.GameObjects.Container,
        _walkingAnimationMapping?: number | WalkingAnimationMapping
    ): void {
        this.scene.gridEngine.addCharacter({
            id: this.name,
            sprite: npcSprite,
            container,
            startPosition: { x: xPosition, y: yPosition },
            facingDirection: this.facingDirection ?? Direction.DOWN,
        })
    }
}
